import React from 'react';
import styled from "styled-components";
import { useSubscription } from '../../hooks/useSubscription';
import { subscriptionsTypes } from '../../scripts/subscription/subscriptionTypes';
import ViewHeader from '../UiComponents/ViewHeader';
import TopNavigation from '../navigation/TopNavigation';
import Button from '../UiComponents/Button';
import Modal from '../UiComponents/Modal';
import { useState } from 'react';
import MusicPlayerSetup from './setup/MusicPlayerSetup';
import MusicPlayerSettings from './MusicPlayerSettings';
import Card from '../UiComponents/Card';
import { ButtonRowContainer } from '../panel/ModalStyles';
import { musicPlayerProviders } from './providers/musicPlayerProviders';
import SoundtrackReauthorizeModal from './providers/soundtrackYourBrand/SoundtrackReauthorizeModal';

const MusicContentViewContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
`

const MusicContentView = (props) => {
    const [musicPlayers, setMusicPlayers] = useSubscription(subscriptionsTypes.musicPlayers);
    const [sources, setSources] = useSubscription(subscriptionsTypes.sources);
    const [hubs, setHubs] = useSubscription(subscriptionsTypes.hubs);
    const [showMusicPlayerSetup, setShowMusicPlayerSetup] = useState(false);
    const [showSoundtrackReauthorization, setShowSoundtrackReauthorization] = useState(false);
    const [musicPlayerAuthorization, setMusicPlayerAuthorization] = useState({});

    const onAuthorizationChange = (musicPlayerId, isAuthorized) => {
        if (typeof isAuthorized !== 'boolean') return;
        setMusicPlayerAuthorization(currentAuthorization => ({
            ...currentAuthorization,
            [musicPlayerId]: isAuthorized
        }));
    }

    const unauthorizedSoundtrackPlayers = musicPlayers?.filter(musicPlayer =>
        musicPlayer.type === musicPlayerProviders.SOUNDTRACK_YOUR_BRAND.key &&
        musicPlayerAuthorization[musicPlayer.musicPlayerId] === false
    ) ?? [];

    const onSoundtrackReauthorized = (musicPlayerIds) => {
        setMusicPlayerAuthorization(currentAuthorization => {
            const updatedAuthorization = { ...currentAuthorization };
            musicPlayerIds.forEach(musicPlayerId => updatedAuthorization[musicPlayerId] = true);
            return updatedAuthorization;
        });
    }

    return <>
        <ViewHeader headerText={'Music Players'} backLink={'/settings'} showVenueName={true} />

        <MusicContentViewContainer>
            <Card>
                <ButtonRowContainer>
                    <Button primary onClick={() => setShowMusicPlayerSetup(true)}>Add music player</Button>
                    {unauthorizedSoundtrackPlayers.length > 0 ?
                        <Button secondary onClick={() => setShowSoundtrackReauthorization(true)}>Reauthorize Soundtrack</Button>
                        : <></>}
                </ButtonRowContainer>
            </Card>

            {musicPlayers?.map(musicPlayer => {
                return <MusicPlayerSettings
                    key={musicPlayer?.musicPlayerId}
                    musicPlayer={musicPlayer}
                    sources={sources}
                    hubs={hubs}
                    onAuthorizationChange={onAuthorizationChange}
                />
            })}

            <Modal show={showMusicPlayerSetup} close={() => setShowMusicPlayerSetup(false)}>
                <MusicPlayerSetup customerId={props.customerId} musicPlayers={musicPlayers} close={() => setShowMusicPlayerSetup(false)}/>
            </Modal>

            <SoundtrackReauthorizeModal
                show={showSoundtrackReauthorization}
                close={() => setShowSoundtrackReauthorization(false)}
                musicPlayers={unauthorizedSoundtrackPlayers}
                onReauthorized={onSoundtrackReauthorized}
            />
        </MusicContentViewContainer>
    </>
}

export default MusicContentView;
